import type { ImportHistoryResponse } from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-363 — read model over the bulk-import batch audit rows (one row per
// POST /import(/csv) batch). Cookie-auth like every other employee-api client.

function commonHeaders(): Record<string, string> {
  return {
    "Content-Type": "application/json",
    ...tenantHeader(),
  };
}

export async function fetchImportHistory(): Promise<ImportHistoryResponse> {
  const res = await apiFetch(`${API_BASE}/employee-api/v1/import/history`, {
    headers: commonHeaders(),
    ...withCredentials,
  });
  return jsonOr401(res);
}
